module.exports = __webpack_public_path__ + "img/LVB.3693a5b8.svg";